export default "__VITE_ASSET__CJ8IxF66__"